import { Bluetooth, Printer, Share2, Usb } from 'lucide-react'
import { createAdapter } from '@/lib/printing/adapters'
import type { PrinterKind } from '@/lib/printing/types'

export interface PrinterOption {
  kind: PrinterKind
  icon: typeof Printer
  title: string
  detail: string
  drawer: boolean
}

/**
 * Every way a receipt can reach paper. One list, shared by Settings and the print dialog
 * itself, so the two never describe the options differently.
 */
export const PRINTER_OPTIONS: PrinterOption[] = [
  {
    kind: 'browser',
    icon: Printer,
    title: 'Browser print dialog',
    detail: 'Uses the printer already installed on this computer. The most reliable choice on a PC.',
    drawer: false,
  },
  {
    kind: 'bluetooth',
    icon: Bluetooth,
    title: 'Bluetooth thermal printer',
    detail:
      'Sends ESC/POS straight to the printer, with no dialog and a working cash-drawer kick. Android only — iPhone browsers cannot use Bluetooth.',
    drawer: true,
  },
  {
    kind: 'webusb',
    icon: Usb,
    title: 'USB thermal printer (direct)',
    detail:
      'No print dialog and a working drawer kick, but the printer must not be claimed by the OS driver — a udev rule on Linux, WinUSB on Windows.',
    drawer: true,
  },
  {
    kind: 'pdf',
    icon: Share2,
    title: 'Share / AirPrint',
    detail:
      'Hands the receipt to the system share sheet for AirPrint or your printer app. The iPhone route: one extra tap, and no drawer kick.',
    drawer: false,
  },
]

/** Only the options this browser could actually use — Bluetooth on iPhone, say, never appears. */
export function availablePrinterOptions(): PrinterOption[] {
  return PRINTER_OPTIONS.filter((option) => createAdapter(option.kind).isSupported())
}
